export default __webpack_public_path__ + "static/media/Background3.f3bf40a4.png";